const Footer = () => {
    return (  
        <footer>
        Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank"  rel="noreferrer">&nbsp;&nbsp;Frontend Mentor</a>. 
      Coded by <a href="https://github.com/adsyahir"
					target="_blank" rel="noreferrer"> &nbsp;Adam Syahir</a>.
        </footer>
    );
}
 
export default Footer;